module.exports = __webpack_public_path__ + "static/student-8a1ba7e8581185de5076835cc3ced12f.png";